import { ComponentStyleConfig } from "@chakra-ui/theme";

const Text: ComponentStyleConfig = {
  variants: {
    "help-text": {
      color: "gray.500",
      fontSize: 14,
      pt: 1,
    },
  },
};

export default Text;
